import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
const tried = ['Una cena "especial" (cara, cansada y dura una noche).', 'Regalos para "salvar la fecha".', 'Decirte "ya cuando pase esta etapa… volvemos".', 'Guardarte lo que sientes para evitar conflicto.'];
export function OldSolutions() {
  return <section className="py-12 px-4 bg-[#0a0a0f]" data-id="element-120">
      <div className="max-w-3xl mx-auto" data-id="element-121">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-122">
          <h2 className="text-xl font-serif text-gray-400" data-id="element-123">
            Lo que has intentado
          </h2>
        </motion.div>

        <div className="space-y-2" data-id="element-124">
          {tried.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} className="flex items-center gap-3 p-3 rounded-lg bg-white/3" data-id="element-125">
              <X className="text-red-400/70 flex-shrink-0" size={18} data-id="element-126" />
              <p className="text-gray-500 text-sm line-through decoration-gray-600/50" data-id="element-127">
                {item}
              </p>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="mt-8 text-center text-gray-400 text-base italic" data-id="element-128">
          Y aun así… vuelve lo mismo:{' '}
          <span className="text-[#ff2d7a]" data-id="element-129">distancia y tensión acumulada.</span>
        </motion.p>
      </div>
    </section>;
}